export const trademarkCopy = `©${new Date().getFullYear()} Nike, Inc. All Rights Reserved`;

type FooterTrademarkProps = {
  className?: string;
};

export function FooterTrademark(props: FooterTrademarkProps) {
  return <p {...props}>{trademarkCopy}</p>;
}
